import type { CSSProperties } from 'react';
import type { UsernameEffect } from '@the-wall/shared';

interface UsernameTextProps {
  text: string;
  color?: string | null;
  effect?: UsernameEffect | null;
  className?: string;
}

export function UsernameText({ text, color, effect, className = '' }: UsernameTextProps) {
  const style = (
    color
      ? {
          color,
          '--username-color': color,
        }
      : undefined
  ) as CSSProperties | undefined;

  if (effect !== 'gold_shimmer') {
    return (
      <span className={className} style={style}>
        {text}
      </span>
    );
  }

  return (
    <span className={`${className} username-shimmer`} style={style}>
      <span className="username-shimmer-base">{text}</span>
      <span className="username-shimmer-overlay" aria-hidden="true">
        {text}
      </span>
    </span>
  );
}
